
export default class Sex {

    Id: number;
    Description: string;

    constructor(id: number, description: string) {
        this.Id = id;
        this.Description = description;
    }

    static NewInstance() {
        return new Sex(0, "");
    }
}